import { FontItalic } from '../../utils/editorReactIcons';
export { FontItalic };
export default FontItalic;
